export const ERROR_MESSAGES = {
  FILE: {
    INVALID_FORMAT: '.jpeg/.jpg/.png/.gif形式の画像をアップロードしてください。',
    MAX_SIZE_EXCEEDED: (size: number) => `ファイルサイズは最大 ${size}MB です。`,
    MAX_AVATAR_SIZE_EXCEEDED: (size: number) => `${size}MB以下の画像を使用してください。`,
    TOO_MANY_FILES: '最大5ファイルまで添付可能です。',
    FILE_TOO_LARGE: (size: number) => `ファイルサイズは${size}MB以下でなければなりません。`,
    UNSUPPORTED_FORMAT: 'サポートされていないファイル形式です。',
    UPLOAD_FAILED: 'アップロードに失敗しました。',
    UPLOAD_FAILED_WITH_CODE: (status: number) =>
      `アップロードに失敗しました。エラーコード: ${status}`,
    ATTACHMENT_NOT_ALLOWED: 'ファイルアップロードが許可されていないチャンネルです。',
  },
  UPLOAD: {
    CHANNEL_REQUIRED: 'チャンネルが指定されていません。',
    PARENT_MESSAGE_REQUIRED: '親メッセージが指定されていません。',
    MESSAGE_OR_FILE_REQUIRED: 'メッセージまたはファイルを入力してください。',
    MAX_LENGTH_EXCEEDED: 'メッセージは5,000文字以内で入力してください。',
    SEND_FAILED: 'メッセージの送信に失敗しました。',
  },
  UPDATE: {
    CHANNEL_REQUIRED: 'チャンネルが指定されていません。',
    NOTFOUND: '更新対象が見つかりませんでした。',
    FAILED: '更新に失敗しました。',
  },
  DELETE: {
    CHANNEL_REQUIRED: 'チャンネルが指定されていません。',
    FAILED: '削除に失敗しました。',
  },
  URL: {
    REQUIRED: 'URLは必須です。',
    INVALID_FORMAT: 'URLの形式が無効です。',
    INVALID_SERVICE: '使用できるサービスはYouTubeまたはVimeoです。',
  },
  IFRAME: {
    REQUIRED: 'iFrameコードは必須です。',
    INVALID_FORMAT: 'iFrameコードの形式が無効です。',
    INVALID_SERVICE: '使用できるサービスはYouTubeまたはVimeoです。',
  },
  TABLE: {
    REQUIRED_ROWS: '行数は必須です。',
    REQUIRED_COLS: '列数は必須です。',
    INVALID_COUNT: '行数または列数に1未満の数値は指定できません。',
  },
};
